<template>
  <div class="emailtemplate">
    <el-dialog
      :show-close="false"
      title="图片下架申诉"
      :visible.sync="appealVisible"
      width="50%"
      :before-close="handleCloseEmail"
      :closeOnPressEscape="false"
      :closeOnClickModal="false"
      center
    >
      <div class="emailcontent flex">
        <div class="list">
          <div class="title">申诉原因（单选）</div>

          <div class="template">
            <div
              class="item"
              :class="item.type === activeIndex ? 'choosed' : ''"
              v-for="(item, index) in reasionList"
              :key="index"
              @click="choosedReason(item, index)"
            >
              <div>{{ item.name }}</div>
            </div>
          </div>
        </div>
        <div class="emailhtml" :key="activeIndex">
          <div class="title">详细原因</div>
          <div class="reson">
            <el-input
              type="textarea"
              :maxlength="300"
              show-word-limit
              v-model="detailReason"
              style="height: 70%; flex: 1"
            />
            <el-input
              type="text"
              placeholder="联系邮箱（可选）"
              :maxlength="50"
              v-model="connectionEmail"
            />
          </div>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <p class="tips" @click="openUrl">《FOSHO情报系统图片申诉下架通知》</p>
        <div class="flex butt">
          <el-button
            type="primary"
            style="margin-right: 10px"
            @click="confirmSave"
            >提交</el-button
          >
          <el-button type="primary" plain @click="gobackTemplate"
            >取消</el-button
          >
        </div>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import { PICTURETOUSU } from "@/api/home";
import {
  GETURLBYID,
} from "@/api/login";
import { Editor, Toolbar } from "@wangeditor/editor-for-vue"; // 引入子组件
import { DomEditor } from "@wangeditor/editor";
export default {
  name: "email",
  components: {
    Editor,
    Toolbar,
  },
  data() {
    return {
      position: "right",
      labelWidth: "100px",
      appealVisible: false,
      confirmState: false,
      form: {},
      rules: {
        name: [{ required: true, message: "请输入模板名称", trigger: "blur" }],
      },
      activeIndex: 1,
      reasionList: [
        {
          type: 1,
          name: "政治",
        },
        {
          type: 2,
          name: "法律",
        },
        {
          type: 3,
          name: "宗教",
        },
        {
          type: 4,
          name: "版权",
        },
        {
          type: 5,
          name: "其他",
        },
      ],
      detailReason: "",
      connectionEmail: "",
    };
  },
  watch: {},

  mounted() {},
  methods: {
    openUrl() {
     
        GETURLBYID({ id: 43 }).then((res) => {
          if (res.data.code == "success") {
            let url = res.data.body;
            window.open(url, "_blank");
          }
        });
      
    },
    init(params) {
      this.activeIndex = 1;
      this.detailReason = '';
      this.connectionEmail = '';
      this.form = params;
      this.appealVisible = true;
    },
    choosedReason(item) {
      this.activeIndex = item.type;
    },
    handleCloseEmail() {
      this.appealVisible = false;
    },
    confirmSave() {
      if (!this.activeIndex)
        return this.$message({ message: "请选择申诉原因", type: "warning" });
      if (this.activeIndex == 5 && !this.detailReason)
        return this.$message({ message: "请填写详细原因", type: "warning" });
      this.form.reportReason = this.activeIndex;
      this.form.detailReason = this.detailReason;
      this.form.connectionEmail = this.connectionEmail;
      PICTURETOUSU(this.form).then((res) => {
        if (res.data.code == "success") {
          this.$message({
            message: "申诉已提交，我们会尽快处理",
            type: "success",
          });
          this.appealVisible = false;
        }
      });
    },
    gobackTemplate() {
      this.appealVisible = false;
    },
  },
};
</script>
<style lang="less" scoped>
.emailcontent {
  width: 100%;
  border: 1px solid #e5e5e5;
  border-radius: 8px;
  box-shadow: 0px 0px 2px 0px #e1e1e1;
  overflow: hidden;

  .list {
    width: 220px;
    border-right: 1px solid #e5e5e5;
    .title {
      text-align: center;
      padding: 11px 11px;
      font-size: 14px;
      font-weight: 600;
      border-bottom: 1px solid #e5e5e5;
    }
    .addbtn {
      text-align: center;
      padding: 8px;
      border-top: 1px solid #e1e1e1;
    }

    .template {
      padding: 8px;
      height: calc(100% - 152px);
      max-height: 70vh;
      overflow-y: scroll;

      .item {
        border-radius: 4px;
        border: 1px solid transparent;
        padding: 8px;
        display: flex;
        cursor: pointer;
        justify-content: space-between;
        align-items: center;
        // border-bottom: 1px solid #e1e1e1;

        &:hover {
          color: #be3c6e;
          .el-icon-edit-outline {
            opacity: 1;
          }
          .el-icon-delete {
            opacity: 1;
          }
        }

        .el-icon-edit-outline {
          color: #0c0909;
          margin-right: 8px;
          opacity: 0;
          cursor: pointer;
          padding: 5px;
          border-radius: 3px;

          &:hover {
            background-color: #d5d5d5;
          }
        }
        .el-icon-delete {
          color: #be3c6e;
          opacity: 0;
          cursor: pointer;
          padding: 5px;
          border-radius: 3px;
          &:hover {
            background-color: #d5d5d5;
          }
        }
      }

      .choosed {
        color: #be3c6e;
        border: 1px solid #be3c6e;
      }

      /* 滚动条优化 start */
      &::-webkit-scrollbar {
        width: 0px;
        height: 0px;
      }

      &::-webkit-scrollbar-track {
        background: #f6f6f6;
        border-radius: 2px;
      }

      &::-webkit-scrollbar-thumb {
        background: #cdcdcd;
        border-radius: 2px;
      }

      &::-webkit-scrollbar-thumb:hover {
        background: #747474;
      }

      &::-webkit-scrollbar-corner {
        background: #f6f6f6;
      }

      /* 滚动条优化 end */
    }
  }
  .emailhtml {
    width: 100%;
    min-height: 40vh;

    .title {
      text-align: center;
      padding: 11px 11px;
      font-size: 14px;
      font-weight: 600;
      border-bottom: 1px solid #e5e5e5;
    }

    .reson {
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      gap: 10px;
      height: calc(100% - 62px);
      padding: 10px;
    }
  }

  
}

.el-dialog--center .el-dialog__body{
  padding-bottom: 0;
}

.tips{
    margin-bottom: 20px;
    text-align: left;
    cursor: pointer;
    color: #be3c6e;
  }
</style>
